const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getCanadianPlusReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CANADIAN_PLUS_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'CANADIAN_PLUS_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'CANADIAN_PLUS_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'CANADIAN_PLUS_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getCanadianPlusReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getCanadianPlusReport.js